<template>
    <tailwind-layout title="Application to Rent">
        <template #header>
    <h2 class="text-lg sm:text-2xl md:text-3xl font-bold leading-7 sm:leading-9 text-center sm:truncate">
        Application to Rent {{ property.full_address }}
    </h2>
</template>

<div class="bg-white bg-rent-risk-blue-100 overflow-hidden rounded-lg">
    <div class="relative max-w-7xl mx-auto py-4 px-2 sm:px-6 lg:px-8">
        <h4 class="text-xl sm:text-2xl md:text-3xl font-bold text-center text-gray-700 mb-4 sm:mb-6">
            Questions
        </h4>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <!-- Form Column -->
            <div class="w-full">
                <form @submit.prevent="store" class="space-y-6 sm:space-y-8 divide-y divide-gray-200">
                    <input type="hidden" id="user_prefs" name="user_prefs">
                    <input type="hidden" id="user_prefs2" name="user_prefs2">

                    <div v-for="(question, index) in questions" class="space-y-4">
                        <p class="text-sm sm:text-base font-medium leading-5">
                            {{ (index+1)+'. '+question.questionText }}
                        </p>
                        <fieldset class="ml-4">
                            <div class="space-y-2">
                                <div v-for="(option, choiceId) in question.questionSelect.questionChoice" :key="'question'+index+'-'+(choiceId+1)" class="flex items-center">
                                    <input :id="'question'+index+'-'+(choiceId+1)" :name="'question'+(index+1)" v-bind:value="(choiceId+1)" v-on:click="updateAnswer(index, (choiceId+1))" type="radio" class="focus:ring-rent-risk-blue-400 h-4 w-4 text-rent-risk-blue-400 border-gray-300" />
                                    <label :for="'question'+index+'-'+(choiceId+1)" class="ml-3 block text-sm font-medium text-gray-700">
                                        {{ option }}
                                    </label>
                                </div>
                            </div>
                            <p v-if="form.errors['question' + (index + 1)]" v-text="form.errors['question' + (index + 1)]" class="text-red-500 text-sm"></p>
                        </fieldset>
                    </div>

                    <div class="pt-5 flex justify-end space-x-4">
                        <inertia-link :href="route('application.steps', application.id)" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400">
                            Cancel
                        </inertia-link>
                        <form-button :form="form" type="submit">
                            Save
                        </form-button>
                    </div>
                </form>
            </div>

            <!-- Test User Questions Column -->
            <div v-if="$page.props.env !== 'PRODUCTION'" class="w-full">
                <ul class="space-y-3">
                    <li v-for="(question, i) in Object.keys(testUserQuestions)" :key="i">
                        <p v-if="i % 2 === 0" class="font-medium">{{ testUserQuestions[question] }}</p>
                        <p v-else class="text-sm text-gray-600 mb-2">{{ testUserQuestions[question] }}</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

    </tailwind-layout>
</template>

<script>
import Icon from '@/Shared/Icon.vue'
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import FormButton from '@/Shared/FormButton.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import SelectInput from "@/Shared/SelectInput.vue"

export default {
    components: {
        Icon,
        TailwindLayout,
        FormButton,
        LoadingButton,
        SelectInput,
    },
    props: {
        property: Object,
        states: Object,
        application: Object,
        questions: Object,
        testUserQuestions: Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                question1: this.question1,
                question2: this.question2,
                question3: this.question3,
                question4: this.question4,
                user_prefs: null,
                user_prefs2: null,
            }),
            property: this.property,
            applicant: this.applicant,
            application: this.application,
        }
    },
    methods: {
        store() {
            this.form.user_prefs = adx.validate('user_prefs');
            this.form.user_prefs2 = adx.validate('user_prefs2');
            this.form.post(this.route('application.questions.submit', this.application.id))
        },
        updateAnswer(question, answer) {
            if((question+1) === 1) {
                this.form.question1 = answer
            }
            else if((question+1) === 2) {
                this.form.question2 = answer
            }
            else if((question+1) === 3) {
                this.form.question3 = answer
            }
            else if((question+1) === 4) {
                this.form.question4 = answer
            }
        },
    }
}
</script>
